import React from "react";
import { Select } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateUI } from "../../../store/actions/deviceProfile";
//import { IsRequiredValidation } from "./formValidation";

function CreateDeviceProfileStep4() {
  const dispatch = useDispatch();
  const formFields = useSelector(
    (state) => state.deviceProfile.ui.form.fields
  );

  const handleFormField = (stateField, field, value) => {
    // If value is 1, force unit to 'hours'
    if (field === 'value' && value === '1') {
      dispatch(
        updateUI({
          key: "form",
          value: {
            fields: {
              ...formFields,
              step4: {
                ...formFields.step4,
                [stateField]: {
                  ...formFields.step4[stateField],
                  value: {
                    ...formFields.step4[stateField].value,
                    value,
                  },
                  unit: {
                    ...formFields.step4[stateField].unit,
                    value: 'hours',
                  },
                },
              },
            },
          },
        })
      );
      return;
    }
    dispatch(
      updateUI({
        key: "form",
        value: {
          fields: {
            ...formFields,
            step4: {
              ...formFields.step4,
              [stateField]: {
                ...formFields.step4[stateField],
                [field]: {
                  ...formFields.step4[stateField][field],
                  value,
                },
              },
            },
          },
        },
      })
    );
  };
  
  return (
    <React.Fragment>
      <div
        className="font-face-vzw"
        style={{
          fontWeight: 700,
          fontSize: "30px",
        }}
      >
        Frequency
      </div>
      <div className="device-profile-create-modal-container py-2">
        <div className="d-flex flex-row justify-content-center align-items-center">
          <span className="w-50 txt-label">Reporting Frequency</span>
          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
              Value
            </span>
            <div className="w-100 pe-2">
              <Select
                className={`shipment-form-fields ${formFields?.step4?.reportingFrequency?.value?.class}`}
                key={"reporting-frequency-value"}
                placeholder="None"
                value={
                  formFields?.step4?.reportingFrequency?.value?.value || "5"
                }
                onChange={(val) =>
                  handleFormField("reportingFrequency", "value", val)
                }
                style={{
                  width: "100%",
                  height: "44px",
                }}
                options={[
                  {
                    value: "1",
                    label: "1",
                  },
                  {
                    value: "5",
                    label: "5",
                  },
                  {
                    value: "15",
                    label: "15",
                  },
                  {
                    value: "30",
                    label: "30",
                  }
                ]}
              />
            </div>
          </div>
          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
              Unit
            </span>
            <div className="w-100 pe-2">
              <Select
                className={`shipment-form-fields ${formFields?.step4?.reportingFrequency?.unit?.class}`}
                key={"reporting-frequency-unit"}
                placeholder="None"
                value={
                  formFields?.step4?.reportingFrequency?.unit?.value || "minute"
                }
                onChange={(val) =>
                  handleFormField("reportingFrequency", "unit", val)
                }
                style={{
                  width: "100%",
                  height: "44px",
                }}
                options={[
                  {
                    value: "hours",
                    label: "Hours",
                  },
                  // Only show 'minutes' if value is not '1'
                  ...(formFields?.step4?.reportingFrequency?.value?.value === '1' ? [] : [{
                    value: "minutes",
                    label: "Minutes",
                  }])
                ]}
              />
            </div>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center align-items-center py-2">
          <span className="w-50 txt-label">Monitoring Frequency</span>
          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
              Value
            </span>
            <div className="w-100 pe-2">
              <Select
                className={`shipment-form-fields ${formFields?.step4?.monitorFrequency?.value?.class}`}
                key={"monitoring-frequency-value"}
                placeholder="None"
                value={
                  formFields?.step4?.monitorFrequency?.value?.value || "5"
                }
                onChange={(val) =>
                  handleFormField("monitorFrequency", "value", val)
                }
                style={{
                  width: "100%",
                  height: "44px",
                }}
                options={[
                  {
                    value: "1",
                    label: "1",
                  },
                  {
                    value: "5",
                    label: "5",
                  },
                  {
                    value: "15",
                    label: "15",
                  },
                  {
                    value: "30",
                    label: "30",
                  }
                ]}
              />
            </div>
          </div>
          <div className="w-50 d-flex flex-column justify-content-center align-items-start">
            <span className="d-flex flex-row justify-content-start align-items-center device-profile-label">
              Unit
            </span>
            <div className="w-100 pe-2">
              <Select
                className={`shipment-form-fields ${formFields?.step4?.monitorFrequency?.unit?.class}`}
                key={"monitoring-frequency-unit"}
                placeholder="None"
                value={
                  formFields?.step4?.monitorFrequency?.unit?.value || "minute"
                }
                onChange={(val) =>
                  handleFormField("monitorFrequency", "unit", val)
                }
                style={{
                  width: "100%",
                  height: "44px",
                }}
                options={[
                  {
                    value: "hours",
                    label: "Hours",
                  },
                  ...(formFields?.step4?.monitorFrequency?.value?.value === '1' ? [] : [{
                    value: "minutes",
                    label: "Minutes",
                  }])
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CreateDeviceProfileStep4;
